<template>
  <div class="page product-page">
    <header class="page-header">
      <h1>产品中心</h1>
      <p>展示 FishROS 核心硬件与系统能力，覆盖机器人开发全流程。</p>
    </header>
    <div class="product-grid">
      <div class="product-card" v-for="product in products" :key="product.name">
        <h3>{{ product.name }}</h3>
        <p>{{ product.desc }}</p>
        <span class="tag">{{ product.tag }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      products: [
        {
          name: 'FishROS 机器人主控板',
          desc: '面向教育与研发的通用主控，支持多协议扩展。',
          tag: '硬件'
        },
        {
          name: 'FishROS 系统镜像',
          desc: '一键部署 ROS / ROS2 环境，提供稳定升级通道。',
          tag: '系统'
        },
        {
          name: 'FishROS 传感器套件',
          desc: '覆盖视觉、雷达与惯导的开发套件组合。',
          tag: '硬件'
        },
        {
          name: '配置助手生态',
          desc: '与硬件深度联动的设备配置与烧录能力。',
          tag: '平台'
        }
      ]
    }
  }
}
</script>

<style scoped>
.page {
  width: 80%;
  margin: 0 auto;
  padding-bottom: 40px;
}
.page-header {
  background: #fff;
  padding: 24px 28px;
  border-radius: 12px;
  margin-bottom: 24px;
}
.page-header h1 {
  margin: 0 0 8px;
  color: #1f2b5b;
}
.page-header p {
  margin: 0;
  color: #666;
}
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}
.product-card {
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid #ececec;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.product-card h3 {
  margin: 0;
  color: #1f2b5b;
}
.product-card p {
  margin: 0;
  color: #666;
  line-height: 1.6;
}
.tag {
  align-self: flex-start;
  background: #edf0ff;
  color: #3d5af1;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
}
@media screen and (max-width: 768px) {
  .page {
    width: 90%;
  }
}
</style>
